"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mock = function () {
    return {
        summary: [
            {
                templateUuid: '6385c3892077b893312b8b60',
                recipientsNum: 10,
            },
            {
                templateUuid: '63874b8ac1aa128f58425785',
                recipientsNum: 2,
            },
            {
                templateUuid: '63874f63c1aa128f58425795',
                recipientsNum: 3,
            },
            {
                templateUuid: '638882b15508f283c548de0b',
                recipientsNum: 0,
            },
            {
                templateUuid: '6388d31dfdde60fa7ebf7188',
                recipientsNum: 234,
            },
        ],
    };
};
exports.default = mock;
